import FIELDS from './moreFromLexisFields'
import { formatAddress, formatDate, titleCase } from '../BusinessDetailReport/businessReportModel'

const list = (value) => (Array.isArray(value) ? value : value != null ? [value] : [])
const isObject = (value) => value && typeof value === 'object' && !Array.isArray(value)
const hasAny = (value, keys) => keys.some(k => k in value)
export const MORE_FROM_LEXIS_HINT = 'Everything else Lexis sent for this record that the lines above don\'t show. Sensitive data, such as SSNs and tax ids, is left out.'
const SENSITIVE = /(^|\/)(SSN|AppendedSSN|AppendSSN|FEIN|TIN|TaxID|TaxId|AppendedTaxId)$/

const show = (value) => {
    if (value == null || value === '') return ''
    if (typeof value === 'boolean') return value ? 'Yes' : 'No'
    if (typeof value === 'number') return String(value)
    if (typeof value === 'string') {
        const text = value.trim()
        const isCode = /\d/.test(text) || /^[A-Z]{1,4}$/.test(text)
        return /[a-z]/.test(text) || isCode ? text : titleCase(text)
    }
    if (!isObject(value)) return ''
    if ('Year' in value) return formatDate(value)
    if (hasAny(value, ['First', 'Last', 'Full'])) return titleCase([value.First, value.Middle, value.Last, value.Suffix].filter(Boolean).join(' ') || value.Full)
    if (hasAny(value, ['StreetName', 'StreetAddress1', 'City', 'Zip5', 'State'])) return formatAddress(value)
    return ''
}

const valuesAt = (record, path) => path.split('/').reduce((nodes, segment) => nodes.flatMap(node => {
    const many = segment.endsWith('[]')
    const value = isObject(node) ? node[many ? segment.slice(0, -2) : segment] : undefined
    return many || Array.isArray(value) ? list(value) : value === undefined ? [] : [value]
}), [record])

export function moreFromLexis(records, root, title = 'More from Lexis', fields = FIELDS) {
    const rows = list(records).filter(isObject)
    const details = (fields[root] || []).filter(([path]) => !SENSITIVE.test(path)).map(([path, label]) => {
        const values = [...new Set(rows.flatMap(r => valuesAt(r, path)).map(show).filter(Boolean))]
        return values.length ? { label, value: values.join('; ') } : null
    }).filter(Boolean)
    return details.length ? { title, details, hint: MORE_FROM_LEXIS_HINT } : null
}
